// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"244":"slider-engie-bonus-data","725":"slider-engie-hp-bonus-data"}[chunkId] || chunkId) + "." + {"244":"865d68b1","453":"2a82d052","725":"8e39315c"}[chunkId] + ".chunk.js";
};